<template>
  <div class="agreement-view-component" v-if="agreementData">
    <el-dialog :title="agreementData.taskname" :visible.sync="dialogVisibleOuter" @closed="closeDialog" width="80%"
      :close-on-click-modal="false">
      <div class="agreement-view">
        <el-row>
          <span>Дата:</span>
          <strong>{{ formatDate(agreementData.dateend) }}</strong>
        </el-row>
        <el-row>
          <span>Автор:</span>
          <strong>{{ agreementData.author }}</strong>
        </el-row>
        <el-row>
          <span>Подразделение:</span>
          <strong>{{ agreementData.division }}</strong>
        </el-row>
        <el-row>
          <span>Контрагент:</span>
          <strong>{{ agreementData.namecounterparty?.value }}</strong>
        </el-row>
        <el-row>
          <span>ИНН:</span>
          <strong>{{ agreementData.inn }}</strong>
        </el-row>
        <el-row>
          <span>КПП:</span>
          <strong>{{ agreementData.kpp }}</strong>
        </el-row>
        <el-row>
          <span>Регион:</span>
          <strong>{{ agreementData.region }}</strong>
        </el-row>
        <el-row>
          <span>Город:</span>
          <strong>{{ agreementData.city }}</strong>
        </el-row>
        <el-row>
          <span>Комментарий:</span>
          <strong>{{ agreementData.description }}</strong>
        </el-row>

        <h3 class="table-title">Направление для открепления</h3>
        <el-table :data="tableData" border style="width: 100%; margin-top: 10px">
          <el-table-column prop="direction" label="Направление" />
          <el-table-column prop="user" label="Пользователь" />
          <el-table-column prop="division" label="Подразделение" />
          <el-table-column label="Согласовано" width="120">
            <template #default="scope">
              <el-checkbox v-model="scope.row.agreed" @change="updateAgreement(scope.$index, scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <div class="actions">
          <el-button :disabled="!hasAgreed" type="success" @click="handleDetach">Открепить</el-button>
          <el-button type="danger" @click="handleReject">Отказать</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { ADRESS } from "@/store/actions/auth";
import moment from "moment";

export default {
  name: "vEnterpriseView",
  props: {
    propAgreement: Object,
    activities: String,
  },
  data() {
    return {
      dialogVisibleOuter: false,
      agreementData: null,
      tableData: [],
    };
  },
  watch: {
    propAgreement(agreement) {
      if (agreement?.БизнесПроцесс === "Открепление предприятий") {
        this.dialogVisibleOuter = true;
        this.getAgreementData(agreement["УИК"]);
      }
    },
  },
  methods: {
    closeDialog() {
      this.agreementData = null;
      this.tableData = [];
      this.$emit("closeDialog");
    },
    async getAgreementData(taskId) {
      const loading = this.$loading({ lock: true });
      try {
        const { data } = await axios.get(
          `${ADRESS}gettask?taskid=${taskId}&type=t`,
          { headers: { Authorization: this.activities } }
        );
        this.agreementData = data.value;
        this.tableData = this.agreementData.listdetachments.map((item) => ({
          ...item,
          agreed: true,
        }));
      } catch (err) {
        console.error(err);
        this.$notify.error({ title: "Ошибка", message: err.message });
      } finally {
        loading.close();
      }
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    updateAgreement(index, row) {
      this.$set(this.tableData, index, row);
    },


    async sendToCRM({ accept, guids, description }) {
      const loading = this.$loading({ lock: true });
      try {
        const resp = await axios.post(
          `${ADRESS}accepttask`,
          {},
          {
            params: {
              taskid: this.propAgreement.УИК,
              accept,
              idtaskaccept: this.propAgreement.УИК,
              guids: guids ? guids.join(",") : undefined,
              description: description ?? (accept ? this.propAgreement.description ?? "" : ""),
            },
            headers: { Authorization: this.activities },
          }
        );
        if (resp.status === 200) {
          this.closeDialog();
          this.$emit("refresh-list");
        }
      } finally {
        loading.close();
      }
    },

    async handleDetach() {
      try {
        await this.$confirm(
          "Вы уверены, что хотите открепить?",
          "Подтверждение",
          { type: "warning" }
        );

        const agreed = this.tableData.filter((row) => row.agreed);
        const notAgreed = this.tableData.filter((row) => !row.agreed);

        const guids = agreed.map((row) => row.guiddirection);

        await this.sendToCRM({
          taskid: this.agreementData.id,
          accept: true,
          guids,
        });

        this.$notify.success({
          title: "Успешно",
          message: notAgreed.length
            ? "Открепление выполнено (частично)"
            : "Открепление выполнено по всем строкам",
        });
      } catch {
        this.$notify.info({ title: "Отмена", message: "Действие отменено" });
      }
    },

    async handleReject() {
      try {
        const { value: reason } = await this.$prompt(
          "Вы уверены, что хотите отказать? Укажите причину отказа:",
          "Отказ от открепления",
          {
            confirmButtonText: "Подтвердить",
            cancelButtonText: "Отмена",
            inputPlaceholder: "Введите причину",
            inputValidator: (value) => {
              if (!value || value.trim().length < 3) {
                return "Причина должна содержать не менее 3 символов";
              }
              return true;
            },
          }
        );

        await this.sendToCRM({
          taskid: this.agreementData.id,
          accept: false,
          description: reason,
        });

        this.$notify.success({
          title: "Успешно",
          message: "Отказ выполнен (все отклонены)",
        });

      } catch (err) {
        this.$notify.info({
          title: "Отмена",
          message: "Действие отменено",
        });
      }
    },
  },
  computed: {
    hasAgreed() {
      return this.tableData.some(row => row.agreed);
    },
  }
};
</script>

<style lang="scss">
.agreement-view-component {
  .el-dialog__body {
    padding-top: 0;

    @media (max-width: 550px) {
      padding: 0 10px;
    }
  }

  .el-dialog__title {
    font-size: 16px;
    line-height: 18px;
    padding-right: 10px;
  }
}

.agreement-view {

  span,
  strong {
    font-size: 14px;
    color: #000;
  }

  .el-row {
    margin: 7px 0;

    >span {
      display: inline-block;
      width: 160px;
      font-weight: 500;
    }
  }

  .table-title {
    margin-top: 20px;
    font-weight: bold;
    font-size: 16px;
  }

  .actions {
    margin-top: 20px;
    text-align: right;

    button {
      margin-left: 10px;
    }
  }
}
</style>
